import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../shared/services/configuration.service';
import { Observable } from 'rxjs/internal/Observable';
import { CompletedFormModel } from '../models/completedForm.model';
import { ReportModel } from '../models/report.model';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private readonly backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.workloadsApiUrl}api`;
  }

  getCompletionFormForTask(id: string): Observable<Array<CompletedFormModel>> {
    return this.http.get<Array<CompletedFormModel>>(
      `${this.backUrl}/CompletionForms/getform?taskId=${id}`
    );
  }

  getStartingFormForTask(id: string): Observable<Array<CompletedFormModel>> {
    return this.http.get<Array<CompletedFormModel>>(
      `${this.backUrl}/WorkStartForms/getform?taskId=${id}`
    );
  }

  getEvaluationFormForTask(id: string): Observable<CompletedFormModel[]> {
    return this.http.get<CompletedFormModel[]>(
      `${this.backUrl}/EvaluationForms/getform?taskId=${id}`
    );
  }

  getCSVReport(model: ReportModel): Observable<string> {
    let params = new HttpParams()
      .set('showNonScheduledTasks', model.ShowNonScheduledTasks);

    if (model.fromDate) {
      params = params.set('fromDate', model.fromDate);
    }

    if (model.toDate) {
      params = params.set('toDate', model.toDate);
    }

    model.taskGroupId?.forEach(id => {
      params = params.append('taskGroupIds', id.toString());
    });

    model.taskJobId?.forEach(id => {
      params = params.append('taskJobIds', id.toString());
    });

    return this.http.get(
      `${this.backUrl}/ExportForm/task-report`,
      {
        params,
        responseType: 'text'
      }
    );
  }

  getAOReportCSV(model: ReportModel): Observable<string> {
    let params = new HttpParams();

    if (model.fromDate) {
      params = params.set('fromDate', model.fromDate);
    }

    if (model.toDate) {
      params = params.set('toDate', model.toDate);
    }

    params = params.set(
      'showNonScheduledTasks',
      String(model.ShowNonScheduledTasks)
    );

    model.taskGroupId?.forEach(id => {
      params = params.append('taskGroupIds', encodeURIComponent(id.toString()));
    });

    model.taskJobId?.forEach(id => {
      params = params.append('taskJobIds', encodeURIComponent(id.toString()));
    });

    return this.http.get(this.backUrl + '/ExportForm/ao-report', {
      params,
      responseType: 'text'
    });
  }
}
